<template>
  <client-only>
    <v-touch @pinchstart="touch_pinchStartHandler" 
             @pinchmove="touch_pinchMoveHandler"
             @pinchend="touch_pinchEndHandler">
      <div ref="photoContainer"
          :class="photoContainerClass"
          @wheel="photoContainer_wheelHandler"
          @click.prevent="photoContainer_clickHandler"
          @mousedown.prevent="photoContainer_mousedownHandler"
          @mousemove.prevent="photoContainer_mousemoveHandler"
          @mouseup.prevent="photoContainer_mouseupHandler"
          @mouseout.prevent="photoContainer_mouseOutHandler"
          @touchstart="photoContainer_touchStartHandler"
          @touchend="photoContainer_touchEndHandler"
          @touchmove="photoContainer_touchMoveHandler"
          @touchcancel="photoContainer_touchCancelHandler"
          @touchleave="photoContainer_touchLeaveHandler"
         >
        <img ref="photo" 
            :src="photoSrcInternal" 
            :style="photoStyle()"
            @load="photo_loadHandler" />
        <div v-if="!photoSrcInternal" class="no-photo-message">
          No photo selected.
        </div>
        <div v-if="!photo.loaded && photoSrcInternal" class="no-photo-message">
          Loading photo...
        </div>
        <div> <!-- Its dumb but we need this div to avoid duplicate id errors -->
          <div v-for="answer in answersInternal" 
              v-bind:key="answer.hotspot.id" 
              class="answer"
              @mouseup="answer_mouseUpHandler(answer, $event)"
              :style="answerStyle(answer)" />
        </div>
        <div v-for="hotspot in hotspotsInternal" 
            v-bind:key="hotspot.id" 
            class="hotspot"
            :style="hotspotStyle(hotspot)" />
        <div class="hotspot active" 
              v-if="mouseHotspot"
              :style="mouseHotspotStyle()" />
        <div class="controls">
          <button @click="zoomInButton_clickHandler">
            <i class="fas fa-search-plus"></i>
          </button>
          <button @click="zoomOutButton_clickHandler">
            <i class="fas fa-search-minus"></i>
          </button>
          <button @click="panButton_clickHandler" :class="panButtonClass">
            <i class="fas fa-arrows-alt" />
          </button>
          <button v-if="edit" @click="addButton_clickHandler" :class="addButtonClass">
            <i class="fas fa-plus-circle" />&nbsp;Hotspot
          </button>
          <div class="instructions" v-if="modeInternal === 'unfocused'">Click to zoom and pan.</div>
          <div class="instructions" v-if="modeInternal === 'pan'">Pinch/scroll to zoom. Click and drag to move. Click outside to scroll page.</div>
          <div class="instructions" v-if="modeInternal === 'add'">Click and drag to create a new hotspot.</div>
        </div>
      </div>
    </v-touch>
  </client-only>
</template>
<script>
import './PhotoContainer.scss';

const colors = ["#FFFF00","#1CE6FF","#FF34FF","#FF4A46","#008941","#006FA6","#A30059","#FFDBE5","#7A4900","#0000A6","#63FFAC","#B79762","#004D43","#8FB0FF","#997D87","#5A0007","#809693","#FEFFE6","#1B4400","#4FC601","#3B5DFF","#4A3B53","#FF2F80","#61615A","#BA0900","#6B7900","#00C2A0","#FFAA92","#FF90C9","#B903AA","#D16100","#DDEFFF","#000035","#7B4F4B","#A1C299","#300018","#0AA6D8","#013349","#00846F","#372101","#FFB500","#C2FFED","#A079BF","#CC0744","#C0B9B2","#C2FF99","#001E09","#00489C","#6F0062","#0CBD66","#EEC3FF","#456D75","#B77B68","#7A87A1","#788D66","#885578","#FAD09F","#FF8A9A","#D157A0","#BEC459","#456648","#0086ED","#886F4C","#34362D","#B4A8BD","#00A6AA","#452C2C","#636375","#A3C8C9","#FF913F","#938A81","#575329","#00FECF","#B05B6F","#8CD0FF","#3B9700","#04F757","#C8A1A1","#1E6E00","#7900D7","#A77500","#6367A9","#A05837","#6B002C","#772600","#D790FF","#9B9700","#549E79","#FFF69F","#201625","#72418F","#BC23FF","#99ADC0","#3A2465","#922329","#5B4534","#FDE8DC","#404E55","#0089A3","#CB7E98","#A4E804","#324E72","#6A3A4C","#83AB58","#001C1E","#D1F7CE","#004B28","#C8D0F6","#A3A489","#806C66","#222800","#BF5650","#E83000","#66796D","#DA007C","#FF1A59","#8ADBB4","#1E0200","#5B4E51","#C895C5","#320033","#FF6832","#66E1D3","#CFCDAC","#D0AC94","#7ED379","#012C58","#7A7BFF","#D68E01","#353339","#78AFA1","#FEB2C6","#75797C","#837393","#943A4D","#B5F4FF","#D2DCD5","#9556BD","#6A714A","#001325","#02525F","#0AA3F7","#E98176","#DBD5DD","#5EBCD1","#3D4F44","#7E6405","#02684E","#962B75","#8D8546","#9695C5","#E773CE","#D86A78","#3E89BE","#CA834E","#518A87","#5B113C","#55813B","#E704C4","#00005F","#A97399","#4B8160","#59738A","#FF5DA7","#F7C9BF","#643127","#513A01","#6B94AA","#51A058","#A45B02","#1D1702","#E20027","#E7AB63","#4C6001","#9C6966","#64547B","#97979E","#006A66","#391406","#F4D749","#0045D2","#006C31","#DDB6D0","#7C6571","#9FB2A4","#00D891","#15A08A","#BC65E9","#FFFFFE","#C6DC99","#203B3C","#671190","#6B3A64","#F5E1FF","#FFA0F2","#CCAA35","#374527","#8BB400","#797868","#C6005A","#3B000A","#C86240","#29607C","#402334","#7D5A44","#CCB87C","#B88183","#AA5199","#B5D6C3","#A38469","#9F94F0","#A74571","#B894A6","#71BB8C","#00B433","#789EC9","#6D80BA","#953F00","#5EFF03","#E4FFFC","#1BE177","#BCB1E5","#76912F","#003109","#0060CD","#D20096","#895563","#29201D","#5B3213","#A76F42","#89412E","#1A3A2A","#494B5A","#A88C85","#F4ABAA","#A3F3AB","#00C6C8","#EA8B66","#958A9F","#BDC9D2","#9FA064","#BE4700","#658188","#83A485","#453C23","#47675D","#3A3F00","#061203","#DFFB71","#868E7E","#98D058","#6C8F7D","#D7BFC2","#3C3E6E","#D83D66","#2F5D9B","#6C5E46","#D25B88","#5B656C","#00B57F","#545C46","#866097","#365D25","#252F99","#00CCFF","#674E60","#FC009C","#92896B"]

export default {
  props: {
    src: [Object, String],
    zoomSpeed: {
      type: Number,
      default: 1
    },
    answers: Array,
    hotspots: Array,
    edit: Boolean,
    mode: Boolean
  },
  data() {
    return {
      modeInternal: 'unfocused',
      answersInternal: [],
      hotspotsInternal: [],
      photoSrcInternal: undefined,
      container: {
        width: 0,
        height: 0
      },
      photo: {
        loaded: false,
        positioned: false,
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        renderWidth: 0,
        renderHeight: 0
      },
      mouse: {
        lastX: undefined,
        lastY: undefined,
        downX: undefined,
        downY: undefined,
        down: false
      },
      touch: {
        lastPageX: undefined,
        lastPageY: undefined,
        downPageX: undefined,
        downPageY: undefined,
        lastScale: 0,
        down: false
      },
      mouseHotspot: undefined
    }
  },
  mounted() {
    this.photoSrcInternal = this.src;
    this.answersInternal = this.answers || [];
    this.hotspotsInternal = this.hotspots || [];
    
    setTimeout(()=> this.resizeHandler(), 200); // TODO: not sure why we need this?
    window.addEventListener('resize', this.resizeHandler);

    window.addEventListener('mousedown', this.window_mousedownHandler);
    window.addEventListener('touchstart', this.window_touchstartHandler);
  },
  computed: {
    panButtonClass() {
      return this.edit ? (this.modeInternal === 'pan' ? 'selected' : '') : 'hide';
    },
    addButtonClass() {
      return this.edit ? (this.modeInternal === 'add' ? 'selected' : '') : 'hide';
    },
    photoContainerClass() {
      if (this.modeInternal === 'unfocused') {
        return 'photo-container unfocused';
      }
      return this.modeInternal === 'pan' ? 'photo-container pan-mode' : 'photo-container add-mode'
    },
    placingNewHotspot() {
      return this.modeInternal === 'add' && this.mouse.down;
    }
  },
  methods: {
    mouseHotspotStyle() {
      if (!this.mouseHotspot) {
        return;
      }
      const color = colors[this.hotspotsInternal.length]; // Make it the color of the "next" hotspot
      const { topPct, leftPct, widthPct, heightPct } = this.mouseHotspot; // This is photo coordinates
      const { renderWidth, renderHeight } = this.photo;
      const [ left, top ] = this.photoToContainer(leftPct * renderWidth, topPct * renderHeight);
      const width = widthPct * renderWidth;
      const height = heightPct * renderHeight;

      return {
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px',
        border: `2px solid ${color}`,
        background: `${color}`,
        opacity: 0.5
      }
    },
    resizeHandler() {
      const _resizeHandler = () => {
        if (!this.$refs.photoContainer) {
          setTimeout(_resizeHandler, 50);
          return;
        }

        this.container.width = this.$refs.photoContainer.offsetWidth;
        this.container.height = this.$refs.photoContainer.offsetHeight;
        
        this.processPhotoLoaded();
        this.resetPhotoPosition();
      }
      setTimeout(_resizeHandler, 50);
    },
    photoStyle() {
      if (this.photo.positioned) {
        return {
          opacity: 1,
          left: `${this.photo.left}px`,
          top: `${this.photo.top}px`,
          width: `${this.photo.renderWidth}px`,
          height: `${this.photo.renderHeight}px`
        }
      }
      return {
        opacity: 0
      }
    },
    hotspotStyle(hotspot) {
      let { topPct, leftPct, widthPct, heightPct, id } = hotspot;
      const { renderWidth, renderHeight } = this.photo;
      const [left, top] = this.photoToContainer(leftPct * renderWidth, topPct * renderHeight);
      const width = widthPct * renderWidth
      const height = heightPct * renderHeight;

      return {
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px',
        border: `2px solid ${colors[id]}`,
        opacity: 0.9
      }
    },
    answerStyle(answer) {
      const { leftPct, topPct } = answer;

      const photoX = leftPct * this.photo.renderWidth;
      const photoY = topPct * this.photo.renderHeight;

      const [containerX, containerY] = this.photoToContainer(photoX, photoY);

      return {
        left: `${containerX}px`,
        top: `${containerY}px`,
        background: colors[answer.hotspot.id]
      }
    },
    resetScale() {
      this.photo.widthScale = this.container.width / this.photo.width;
      this.photo.heightScale = this.container.height / this.photo.height;

      // Resize to the smallest of width or height
      if (this.photo.widthScale <= this.photo.heightScale) {
        this.photo.renderWidth = this.container.width;
        this.photo.renderHeight = this.photo.height * this.photo.widthScale;
        this.photo.scale = this.photo.widthScale;
      } else {
        this.photo.renderHeight = this.container.height;
        this.photo.renderWidth = this.photo.width * this.photo.heightScale;
        this.photo.scale = this.photo.heightScale;
      }
    },
    resetCenter() {
      this.photo.left = (this.container.width / 2) - (this.photo.renderWidth / 2);
      this.photo.top = (this.container.height / 2) - (this.photo.renderHeight / 2);
      this.photo.optimalLeft = this.photo.left;
      this.photo.optimalTop = this.photo.top;
    },
    resetPhotoPosition() {
      // Don't bother trying to reset if the values are not yet populated.
      if (this.photo.width && this.container.width) {
        this.resetScale();
        this.resetCenter();

        this.photo.optimalWidth = this.photo.renderWidth;
        this.photo.optimalHeight = this.photo.renderHeight;

        this.photo.positioned = true;

        this.$forceUpdate();
      }
    },
    zoom({ delta, centerX, centerY, scale, pageCenterX, pageCenterY }) {
      // Okay we need to zoom into the centerPoint, and scale by deltaY in the process.
      // First calculate the new width and height and then make sure that the center is 
      // still focused where the center passed in is at.
      if (pageCenterX !== undefined) {
        const containerOffset = this.$refs.photoContainer.getBoundingClientRect();
        const containerLeft = containerOffset.left;
        const containerTop = containerOffset.top;

        const centerXContainer = pageCenterX - containerLeft;
        const centerYContainer = pageCenterY - containerTop;

        const [ cX, cY ] = this.containerToPhoto(centerXContainer, centerYContainer);
        centerX = cX;
        centerY = cY;
      }

      let deltaPct = scale !== undefined ? scale : (delta / 20) * this.zoomSpeed;

      if (deltaPct < 0) {
        deltaPct = deltaPct * 2;
        // Zoom out toward the optimal values
        const topDelta = this.photo.top - this.photo.optimalTop;
        const leftDelta = this.photo.left - this.photo.optimalLeft;
        const widthDelta = this.photo.renderWidth - this.photo.optimalWidth;
        const heightDelta = this.photo.renderHeight - this.photo.optimalHeight;

        this.photo.top += topDelta * deltaPct;
        this.photo.left += leftDelta * deltaPct;
        this.photo.renderWidth += widthDelta * deltaPct;
        this.photo.renderHeight += heightDelta * deltaPct;

        if (Math.abs(this.photo.renderWidth - this.photo.optimalWidth) < 0.9 || this.photo.renderWidth < this.photo.optimalWidth) {
          this.photo.renderWidth = this.photo.optimalWidth;
          this.photo.renderHeight = this.photo.optimalHeight;
          this.resetCenter();
        }

        if (this.photo.renderWidth === this.photo.optimalWidth && this.photo.renderHeight === this.photo.optimalHeight) {
          return false;
        }

        return true;
      }
      else {
        if (centerX < 0 || centerX > this.photo.renderWidth) {
          centerX = this.photo.renderWidth / 2;
        }

        if (centerY < 0 || centerY > this.photo.renderHeight) {
          centerY = this.photo.renderHeight / 2;
        }

        let centerXPct = centerX / this.photo.renderWidth;
        let centerYPct = centerY / this.photo.renderHeight;

        let newRenderWidth = this.photo.renderWidth * (1 + deltaPct);
        let newRenderHeight = newRenderWidth * this.photo.heightAspectRatio;

        if (newRenderWidth >= this.photo.width) {
          newRenderWidth = this.photo.width;
          newRenderHeight = this.photo.height;
        }

        const widthDelta = newRenderWidth - this.photo.renderWidth;
        const heightDelta = newRenderHeight - this.photo.renderHeight;

        if (Math.abs(widthDelta) > 0.5 && Math.abs(heightDelta) > 0.5) {
          this.photo.renderWidth = newRenderWidth;
          this.photo.renderHeight = newRenderHeight;

          this.photo.left -= widthDelta * centerXPct;
          this.photo.top -= heightDelta * centerYPct;

          return true;
        }

        return false;
      }
    },
    move({ x, y }) {
      this.photo.left += x;
      this.photo.top += y;
    },
    containerToPhoto(x, y) {
      const photoX = x - this.photo.left;
      const photoY = y - this.photo.top;

      return [ photoX, photoY ];
    },
    photoToContainer(x, y) {
      const containerX = this.photo.left + x;
      const containerY = this.photo.top + y;

      return [ containerX, containerY ];
    },
    photoCoordWithinPhoto(x, y) {
      return x > 0 && x < this.photo.renderWidth && y > 0 && y < this.photo.renderHeight;
    },
    photoCoordToPercent(x, y) {
      const xPct = x / this.photo.renderWidth;
      const yPct = y / this.photo.renderHeight;

      return [ xPct, yPct ];
    },
    processPhotoLoaded() {
      const { photo } = this.$refs;

      if (photo) {
        this.photo.width = photo.naturalWidth;
        this.photo.height = photo.naturalHeight;
        this.photo.heightAspectRatio = this.photo.height / this.photo.width;

        this.photo.loaded = true;
        
        this.resetPhotoPosition();
      }
    },
    //-------------------------------------------------------------------------------------
    //
    // Active Hotspot
    //
    //-------------------------------------------------------------------------------------
    setMouseHotspotFromContainerCoord({ left, top, width, height }) {
      const [ leftPhoto, topPhoto ] = this.containerToPhoto(left, top);
      const [ leftPct, topPct ] = this.photoCoordToPercent(leftPhoto, topPhoto);
      
      const widthPct = width / this.photo.renderWidth;
      const heightPct = height / this.photo.renderHeight;

      const photoWidth = this.photo.width * widthPct;
      const photoHeight = this.photo.height * heightPct;

      return this.mouseHotspot = {
        leftPct, topPct, widthPct, heightPct, left, top, width: photoWidth, height: photoHeight
      };
    },
    //-------------------------------------------------------------------------------------
    //
    // Photo Events
    //
    //-------------------------------------------------------------------------------------
    photo_loadHandler() {
      this.photo.loaded = true;

      this.processPhotoLoaded();
    },
    //-------------------------------------------------------------------------------------
    //
    // Mouse Events
    //
    //-------------------------------------------------------------------------------------
    photoContainer_wheelHandler(event) {
      if (this.modeInternal === 'pan') {
        const { offsetX, offsetY, deltaY } = event;

        const [x, y] = this.containerToPhoto(offsetX, offsetY);

        const changed = this.zoom({ delta: -deltaY, centerX: x, centerY: y });

        event.stopPropagation();
        event.preventDefault();
      }
    },
    photoContainer_mousedownHandler(event) {
      if (this.modeInternal === 'unfocused') {
        this.modeInternal = 'pan';
      }

      this.mouse.lastX = this.mouse.downX = event.offsetX;
      this.mouse.lastY = this.mouse.downY = event.offsetY;
      this.mouse.down = true;

      event.stopPropagation();
      event.preventDefault();
    },
    photoContainer_mousemoveHandler(event) {
      if (this.mouse.down) {
        const xDelta = event.offsetX - this.mouse.lastX;
        const yDelta = event.offsetY - this.mouse.lastY;
        const xDeltaTotal = event.offsetX - this.mouse.downX;
        const yDeltaTotal = event.offsetY - this.mouse.downY;
        
        this.mouse.lastX = event.offsetX;
        this.mouse.lastY = event.offsetY;

        if (this.modeInternal === 'pan') {
          this.move({ x: xDelta, y: yDelta });
        } else if (this.modeInternal === 'add') {
          // Container Coordinates here.
          const left = xDeltaTotal > 0 ? this.mouse.downX : this.mouse.lastX;
          const top = yDeltaTotal > 0 ? this.mouse.downY : this.mouse.lastY;
          const width = Math.abs(xDeltaTotal);
          const height = Math.abs(yDeltaTotal);

          this.setMouseHotspotFromContainerCoord({ left, top, width, height });
        }
      }
    },
    photoContainer_mouseupHandler(event) {
      // Internal click event
      if (this.mouse.downX === event.offsetX && this.mouse.downY === event.offsetY) {
        const [x, y] = this.containerToPhoto(event.offsetX, event.offsetY);

        if (this.photoCoordWithinPhoto(x, y)) {
          const [leftPct, topPct] = this.photoCoordToPercent(x, y);

          // For external listeners
          this.$emit('photoClick', { leftPct, topPct });
        }
      }

      // Hotspot Creation (e.g. drag and select)
      if (this.mouseHotspot) {
        this.$emit('hotspotCreated', this.mouseHotspot);
      }

      this.mouseHotspot = undefined;
      this.mouse.down = false;
      this.mouse.lastX = this.mouse.downX = undefined;
      this.mouse.lastY = this.mouse.downY = undefined;
    },
    photoContainer_clickHandler(event) {
      // NOOP
    },
    photoContainer_mouseOutHandler(event) {
      this.mouseHotspot = undefined;
      this.mouse.down = false;
      this.mouse.lastX = this.mouse.lastY = this.mouse.downX = this.mouse.downY = undefined;
    },
    answer_mouseUpHandler(answer, event) {
      if (this.mouse.downX === event.offsetX && this.mouse.downY === event.offsetY) {
          this.$emit('answerClick', answer);
      }

      this.mouse.down = false;
      event.stopPropagation();
      event.preventDefault();
    },
    //-------------------------------------------------------------------------------------
    //
    // Touch Events
    //
    //-------------------------------------------------------------------------------------
    photoContainer_touchStartHandler(event) {
      if (this.modeInternal === 'unfocused') {
        this.modeInternal = 'pan';
      }

      this.touch.down = true;
      this.touch.lastPageX = event.changedTouches[0].pageX;
      this.touch.lastPageY = event.changedTouches[0].pageY;
    },
    photoContainer_touchMoveHandler(event) {
      if (this.touch.down && event.touches.length === 1) {
        const { pageX, pageY } = event.changedTouches[0];

        const xDelta = pageX - this.touch.lastPageX;
        const yDelta = pageY - this.touch.lastPageY;

        this.touch.downPageX = this.touch.lastPageX = pageX;
        this.touch.downPageY = this.touch.lastPageY = pageY;

        if (this.modeInternal === 'pan') {
          this.move({ x: xDelta, y: yDelta });
        } // 'add' modeInternal not supported
      }
    },
    photoContainer_touchEndHandler(event) {
      this.touch.down = false;
      this.touch.downPageX = this.touch.lastPageX = undefined;
      this.touch.downPageY = this.touch.lastPageY = undefined;
    },
    photoContainer_touchLeaveHandler(event) {
      this.touch.down = false;
      this.touch.downPageX = this.touch.lastPageX = undefined;
      this.touch.downPageY = this.touch.lastPageY = undefined;
    },
    photoContainer_touchCancelHandler(event) {
      this.touch.down = false;
      this.touch.downPageX = this.touch.lastPageX = undefined;
      this.touch.downPageY = this.touch.lastPageY = undefined;
    },
    touch_pinchStartHandler(event) {
      this.touch.lastScale = 0;
    },
    touch_pinchMoveHandler(event) {
      const scaleDelta = event.scale - this.touch.lastScale;
      if (Math.abs(scaleDelta) < 0.1) {
        this.zoom({ scale: scaleDelta, pageCenterX: event.center.x, pageCenterY: event.center.y});
      }
      this.touch.lastScale = event.scale;
    },
    touch_pinchEndHandler(event) {
      this.touch.lastScale = 0;
    },
    window_mousedownHandler(event) {
      this.modeInternal = 'unfocused';
    },
    window_touchstartHandler(event) {
      if (this.$refs.photoContainer && !this.$refs.photoContainer.contains(event.target)) {
        this.modeInternal = 'unfocused';
      }
    },
    zoomInButton_clickHandler(event) {
      const [centerX, centerY] = this.containerToPhoto(this.container.width / 2, this.container.height / 2);

      this.zoom({
        scale: 0.4,
        centerX,
        centerY
      });
    },
    zoomOutButton_clickHandler(event) {
      const [centerX, centerY] = this.containerToPhoto(this.container.width / 2, this.container.height / 2);

      this.zoom({
        scale: -0.4,
        centerX,
        centerY
      });
    },
    //-------------------------------------------------------------------------------------
    //
    // Button Events
    //
    //-------------------------------------------------------------------------------------
    panButton_clickHandler() {
      this.modeInternal = 'pan';
    },
    addButton_clickHandler() {
      this.modeInternal = 'add';
    }
  },
  watch: { 
    src: function(newVal, oldVal) {
      this.photoSrcInternal = newVal;
      this.$forceUpdate();
    },
    answers: function(newVal, oldVal) {
      this.answersInternal = newVal;
      this.$forceUpdate();
    },
    hotspots: function(newVal, oldVal) {
      this.hotspotsInternal = newVal;
      this.$forceUpdate();
    }
  }
}
</script>
